import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=a7c83aae&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=a7c83aae&prod&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=a7c83aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c83aae",
  null
  
)

export default component.exports